module.exports = __webpack_public_path__ + "static/media/2.question.7aa9eb1a.mp4";